const infractionTransactionType = {
  TRANSFER: 'TRANSFER',
  REFUND: 'REFUND',
  DEPOSIT: 'DEPOSIT',
  DEPOSIT_REFUND: 'DEPOSIT_REFUND'
};

module.exports = infractionTransactionType;
